import { pageTitle } from "../PageTitle";

import HeaderOne from "../Header/HeaderOne";
import FooterOne from "../Footer/FooterOne";
import AiInvoiceBanner from "./../../assets/images/banner/fo.png";

const Wa_Food_Ord = () => {
  pageTitle("Whatsapp Food Ordering");

  return (
    <>
      <HeaderOne></HeaderOne>

      <div
        className="ai-overlay-wrapper"
        style={{ backgroundImage: `url(${AiInvoiceBanner})` }}
      >
        {/* <img src={AiInvoiceBanner} alt="AI Operations" className="main" /> */}

        <div className="ai-overlay">
          {/* Centered text */}
          <div className="ai-overlay-center-project-text">
            <h2 className="ai-overlay-project">
              AI-Powered <br></br>Whatsapp Food Ordering
            </h2>
          </div>
        </div>
      </div>

      <section className="siw-rpa-section" style={{ marginBottom: "30px" }}>
        <div className="siw-rpa-container container mb-5">
          <div className="row align-items-stretch">
            <h3 className="siw-project-heading">
              One voice note is all it takes — automate your food orders
              instantly through WhatsApp.
            </h3>
            {/* LEFT SIDE - VIDEO */}
            <div className="col-md-6 mt-2 d-flex flex-column">
              <div className="siw-project-video-wrapper">
                <iframe
                  className="siw-project-video"
                  src="https://www.youtube.com/embed/wmpuRPpPTP4?si=rdtO9M1k_lEev4RL"
                  title="Introducing Text To Speech"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>

            {/* RIGHT SIDE - CTA */}
            <div className="col-md-6 mt-2 d-flex">
              <div className="siw-rpa-cta w-100 d-flex flex-column justify-content-center text-center">
                <h4 style={{ color: "rgb(230, 233, 55)" }}>
                  Free Trial Available
                </h4>

                <p>
                  <span style={{ fontSize: "20px", fontWeight: "bold" }}>
                    SiW
                  </span>{" "}
                  is currently offering a free trial session for businesses
                  looking to modernize food ordering through WhatsApp and AI.
                </p>

                <p>
                  Our team will build a dedicated AI-powered ordering system
                  tailored to your workflow — allowing customers to order via
                  text or voice, reducing manual effort, and ensuring faster,
                  error-free order processing.
                </p>

                <a href="/contact" className="siw-rpa-btn mt-3">
                  <i className="bi bi-calendar-week btn-icon"></i>
                  Start a Free Trial
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FooterOne></FooterOne>
    </>
  );
};
export default Wa_Food_Ord;
